'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { getAuth } from 'firebase/auth'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth'
import { Error, NavHeader, RequestMiddlewareWrapper } from '@/components'
import { FirebaseServiceProviders } from '@/lib/firebase/FirebaseServiceProviders'
import { useClientTranslation } from './i18n/client'
import { ClientTranslationProvider } from './i18n/client/context'
import { defaultLanguage } from './i18n/config'

const queryClient = new QueryClient()

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  const router = useRouter()
  const { t } = useClientTranslation(['common'])
  const [user, _loading] = useAuthState(getAuth())

  useEffect(() => {
    console.error(error)
  }, [error])

  const handleReturnHome = () => {
    router.replace('/')
  }
  const showHoverMenu = !!user

  return (
    <html>
      <body>
        <FirebaseServiceProviders>
          <ClientTranslationProvider lang={defaultLanguage}>
            <RequestMiddlewareWrapper>
              <QueryClientProvider client={queryClient}>
                <NavHeader showHoverMenu={showHoverMenu} />
                <Error
                  errorCode={500}
                  onReturnHome={handleReturnHome}
                  returnToHomeButtonText={t('buttons.returnToHome')}
                />
              </QueryClientProvider>
            </RequestMiddlewareWrapper>
          </ClientTranslationProvider>
        </FirebaseServiceProviders>
      </body>
    </html>
  )
}
